var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAaveLogo = function SvgAaveLogo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 800 220",
    ref: ref,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient-4);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 402.38,
    y1: 608.02,
    x2: 416.27,
    y2: 611.26,
    gradientTransform: "matrix(55.73, 0, 0, -61.13, -22399.38, 37390.17)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#31bac6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b6509e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 398.46,
    y1: 607.05,
    x2: 416.8,
    y2: 610.33,
    gradientTransform: "matrix(42.21, 0, 0, -60.24, -16781.26, 36852.38)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 403.19,
    y1: 608.4,
    x2: 417.06,
    y2: 611.63,
    gradientTransform: "matrix(55.78, 0, 0, -61.13, -22470.38, 37393.23)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 404.08,
    y1: 609.27,
    x2: 417.96,
    y2: 612.51,
    gradientTransform: "matrix(55.78, 0, 0, -61.13, -22536.12, 37390.77)",
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "MediaKit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4051",
    "data-name": "Group 4051"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2431",
    "data-name": "Path 2431",
    className: "cls-1",
    d: "M490.08,203.2,415.34,21.93a15.83,15.83,0,0,1-.92-5.15,14.2,14.2,0,0,1,3.67-10.1A12.86,12.86,0,0,1,428,2.83a13.31,13.31,0,0,1,7.71,2.57,16.37,16.37,0,0,1,5.33,6.79l71.07,177.42L583.19,12.19a16.27,16.27,0,0,1,5.32-6.79,13.31,13.31,0,0,1,7.71-2.57,12.86,12.86,0,0,1,9.92,3.85,14.2,14.2,0,0,1,3.67,10.1,15.77,15.77,0,0,1-.92,5.14L534.15,203.2c-4.21,9.37-10.47,14-18.73,14h-6.61C500.55,217.16,494.3,212.57,490.08,203.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2432",
    "data-name": "Path 2432",
    className: "cls-2",
    d: "M641.58,211.65a13.31,13.31,0,0,1-3.86-9.74V18.25a14,14,0,0,1,3.86-9.91,12.74,12.74,0,0,1,9.73-4H772.7a12.07,12.07,0,0,1,9.18,3.85,12.37,12.37,0,0,1,3.86,9.19,11.7,11.7,0,0,1-3.86,9A12.93,12.93,0,0,1,772.7,30H665.27V96.87h96.59a12.08,12.08,0,0,1,9.18,3.86,12.6,12.6,0,0,1,3.86,9.18,11.7,11.7,0,0,1-3.86,9,12.84,12.84,0,0,1-9.18,3.67H665.27V189.8H772.7a12,12,0,0,1,9.18,3.86,12.33,12.33,0,0,1,3.86,9.18,11.7,11.7,0,0,1-3.86,9,12.93,12.93,0,0,1-9.18,3.67H651.31A12,12,0,0,1,641.58,211.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2433",
    "data-name": "Path 2433",
    className: "cls-3",
    d: "M432.23,198.06,357.5,16.78C353.29,7.42,347,2.83,338.77,2.83h-6.62c-8.27,0-14.51,4.59-18.73,14l-32.51,79h-24.6a13.49,13.49,0,0,0-13.41,13.41v.18a13.48,13.48,0,0,0,13.41,13.41h13.22l-31,75.3a15.81,15.81,0,0,0-.92,5.14,14.19,14.19,0,0,0,3.67,10.1,12.87,12.87,0,0,0,9.92,3.86,13.45,13.45,0,0,0,7.71-2.57,16.46,16.46,0,0,0,5.33-6.8l34.15-85h23.49a13.49,13.49,0,0,0,13.41-13.41V109a13.48,13.48,0,0,0-13.41-13.41H309.18l26.27-65.2,71.07,177.42a16.27,16.27,0,0,0,5.32,6.79,13.31,13.31,0,0,0,7.72,2.57,12.86,12.86,0,0,0,9.91-3.85,14.21,14.21,0,0,0,3.67-10.11A12,12,0,0,0,432.23,198.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2434",
    "data-name": "Path 2434",
    className: "cls-4",
    d: "M208.93,198.06,134.2,16.78C130,7.42,123.72,2.83,115.45,2.83h-6.61c-8.26,0-14.5,4.59-18.73,14l-32.5,79H33a13.5,13.5,0,0,0-13.41,13.41v.18A13.5,13.5,0,0,0,33,122.76H46.22l-31,75.3a15.81,15.81,0,0,0-.92,5.14,14.17,14.17,0,0,0,3.67,10.1,12.87,12.87,0,0,0,9.92,3.86,13.45,13.45,0,0,0,7.71-2.57,16.46,16.46,0,0,0,5.33-6.8l34.15-85H98.74a13.49,13.49,0,0,0,13.41-13.41V109A13.48,13.48,0,0,0,98.74,95.59H86.07l26.08-65.21,71.07,177.41a16.3,16.3,0,0,0,5.33,6.8,13.45,13.45,0,0,0,7.71,2.57,12.91,12.91,0,0,0,9.92-3.86,14.2,14.2,0,0,0,3.67-10.1A12.21,12.21,0,0,0,208.93,198.06Z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAaveLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/aave-logo.58aec338176d9218d6d4d5a22a6d8955.svg";